import PropTypes from "prop-types"
// Components
import ImageGrid from "../ImageGrid/ImageGrid"
import ScrollButton from "../ScrollButton/ScrollButton"
// Styles
import {
   Container,
   Wrapper,
   Image,
   Text,
   Title,
} from "./PageSectionSplitThird.styles"

const PageSectionSplitThird = ({
   imageLeft,
   imageRight,
   title,
   text,
   patchworkLeft,
   patchworkRight,
   scrollContainer,
}) => {
   return (
      <Container>
         {imageLeft ? (
            <Image src={imageLeft} />
         ) : (
            <ImageGrid pictures={patchworkLeft} />
         )}
         <Wrapper>
            <Title
               dangerouslySetInnerHTML={{
                  __html: title?.replace(/\n/g, "<br />"),
               }}
            />
            <Text
               dangerouslySetInnerHTML={{
                  __html: text?.replace(/\n/g, "<br />"),
               }}
            />
         </Wrapper>
         {imageRight ? (
            <Image src={imageRight} />
         ) : (
            <ImageGrid pictures={patchworkRight} />
         )}
         <ScrollButton orientation="down" scrollContainer={scrollContainer} />
      </Container>
   )
}

PageSectionSplitThird.propTypes = {
   imageLeft: PropTypes.string,
   imageRight: PropTypes.string,
   title: PropTypes.string,
   text: PropTypes.string,
   patchworkLeft: PropTypes.arrayOf(PropTypes.string),
   patchworkRight: PropTypes.arrayOf(PropTypes.string),
   scrollContainer: PropTypes.object,
}

export default PageSectionSplitThird
